import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function getTeacherDayTimetable(payload) {
  return { type: actionTypes.GET_TEACHERDAY_TIMETABLE, payload };
}
export function getTeacherDayTimetableSuccess(payload) {
  const byId = keyBy(payload, (timetable) => timetable.teacherdayUid);
  return { type: actionTypes.GET_TEACHERDAY_TIMETABLE_SUCCESS, payload: { byId } };
}
